import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  margin-bottom: ${RFValue(6)}px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};

`;

export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(4)}px;
  margin-bottom: ${RFValue(20)}px;
`;
